import React from 'react';
import { Typography } from '@mui/material';
import MainTemplate from '../templates/MainTemplate';

function FinishView({ viewParameters, templateRef }) {

    if (!viewParameters || !viewParameters.estilos) return null;

    return (
        <MainTemplate templateRef={templateRef} view={viewParameters}>            
            <Typography sx={viewParameters.estilos.cuerpo}>
                {viewParameters.mensaje}
            </Typography>
            
        </MainTemplate>
    );
}

export default FinishView;